var Model = require('Model');
var Project = require('./Project');
var Events = require('Events');

var Container = Model.extend({

    includes: Events,

    options: {
        project: undefined
    },

    initialize: function(){
        var that = this;
        Container.__super__.initialize.apply(that, arguments);

        // TODO: Возможно это стоит перенести в класс слоя.
        // Контейнер нельзя инициализировать без проекта.
        if(!(that.options['project'] instanceof Project)){
            throw new Error('Project is required to initialize container');
        }

        that.project = that.options['project'];
    },

    set: function(attr, value, silent) {
        var that = this;
        var attrsHash = JSON.stringify(that._attributes);

        if (_.isObject(attr)) {
            silent = value;
        }

        Container.__super__.set.call(that, attr, value);

        if (that.project && !silent) {
            that.project.fire('containerSet', {
                container: that
            });

            if (attrsHash !== JSON.stringify(that._attributes)) {
                that.project.fire('containerChanged', {
                    container: that
                });
            }
        }
    }
});

module.exports = Container;



//////////////////
// WEBPACK FOOTER
// ./src/Project/Container.js
// module id = 13
// module chunks = 0